import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuroraLogo } from "@/components/AuroraLogo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password: pwd });
      toast.success("Password updated. Sign in with your new password.");
      nav("/");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid-lines flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="holo-panel corners w-full max-w-md p-8 sm:p-10" data-testid="reset-password-form">
        <AuroraLogo size={48} />
        <div className="eyebrow mt-8">Security // Credentials</div>
        <h1 className="mt-3 font-display text-2xl font-extrabold">Choose a new password</h1>
        <label className="mt-8 block">
          <span className="mono-label">New password</span>
          <input type="password" minLength={6} required className="field mt-2" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password-input" />
        </label>
        <button className="btn-primary mt-6 w-full" disabled={busy} data-testid="reset-password-submit">{busy ? "Updating…" : "Update password"}</button>
        <Link to="/" className="mt-6 inline-block font-mono text-xs text-muted-foreground hover:text-[color:var(--au-green)]" data-testid="reset-back-link">← BACK</Link>
      </form>
    </div>
  );
}
